import { categories } from '@/mocks/categories';

export default function CategoryGrid() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-800 text-xs font-semibold rounded-full tracking-wide uppercase mb-4">
            Browse Products
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
            OOPBuy Spreadsheet Categories
          </h2>
          <p className="mt-4 text-foreground-600 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Explore all product categories available in the OOPBuy Spreadsheet. Click any category to browse items on the main platform.
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 xl:grid-cols-5 gap-4 md:gap-5">
          {categories.map((cat) => (
            <a
              key={cat.id}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block cursor-pointer"
            >
              <div className="relative overflow-hidden rounded-xl aspect-[3/4]">
                <img
                  src={cat.imageUrl}
                  alt={`${cat.name} - OOPBuy Spreadsheet product category`}
                  title={`${cat.name} | OOPBuy Spreadsheet`}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-black/15 to-transparent"></div>
                <div className="absolute bottom-0 left-0 right-0 p-3 md:p-4">
                  <span className="text-background-50 font-heading text-sm md:text-base font-semibold whitespace-nowrap block">
                    {cat.name}
                  </span>
                </div>
              </div>
              <div className="mt-2 px-1">
                <p className="text-foreground-600 text-xs leading-relaxed line-clamp-1">
                  {cat.description}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}